import React from "react";
import { Modal, Button, Message } from "semantic-ui-react";
import { translate } from "react-i18next";

class MessageModal extends React.Component {
	render() {
		const { t } = this.props;
		return (
			<Modal open={this.props.show}>
                <Modal.Header>
                    {this.props.negative &&
                        <h3>{t("errorMessage")}</h3>
                    }
                    {this.props.positive &&
                        <h3>{t("infoMessage")}</h3>
                    }
                    {this.props.warrning &&
                        <h3>{t("warningMessage")}</h3>
                    }
                </Modal.Header>
				<Modal.Content>
					<Message negative={this.props.negative}>
						<Message.Header>
					        {this.props.message}
						</Message.Header>
					</Message>
				</Modal.Content>
				<Modal.Actions>
					<Button onClick={this.props.onHide}>{t("close")}</Button>
				</Modal.Actions>
			</Modal>
		);
	}
}

export default translate()(MessageModal);



// WEBPACK FOOTER //
// ./src/features/common/message/MessageModal.jsx